const breakPoint = 768;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();



// ------------------------------------------------------------------------
// createCanvas
// ----- BOTH
// ------------------------------------------------------------------------
const createCanvas = () => {
  const targetLeftList  = document.querySelectorAll('.sw-Canvas.sw-Canvas-Left');
  const targetLeftArray = Array.prototype.slice.call(targetLeftList,0);
  const fillLeft = (e, w) => {
    e.fillStyle = 'rgba(247, 208, 2, 1)';
    e.beginPath();
    if (w > breakPoint) {
      e.moveTo(800  * 2, 0);
      e.lineTo(1920 * 2, 0);
      e.lineTo(1920 * 2, 125 * 2);
    } else {
      e.moveTo(3840 * (102 / 768), 0);
      e.lineTo(3840,               0);
      e.lineTo(3840,               250 * (75 / 100));
    }
    e.fill();
    e.fillStyle = 'rgba(1, 142, 66, 1)';
    e.beginPath();
    if (w > breakPoint) {
      e.moveTo(0,        0);
      e.lineTo(1920 * 2, 0);
      e.lineTo(1920 * 2, 32 * 2);
      e.lineTo(0,        125 * 2);
    } else {
      e.moveTo(0, 0);
      e.lineTo(3840, 0);
      e.lineTo(3840, 250 * (30  / 100));
      e.lineTo(0,    250 * (100 / 100));
    }
    e.fill();
  };
  const targetRightList  = document.querySelectorAll('.sw-Canvas.sw-Canvas-Right');
  const targetRightArray = Array.prototype.slice.call(targetRightList,0);
  const fillRight = (e, w) => {
    e.fillStyle = 'rgba(247, 208, 2, 1)';
    e.beginPath();
    if (w > breakPoint) {
      e.moveTo(1120 * 2, 0);
      e.lineTo(0,        0);
      e.lineTo(0,        125 * 2);
    } else {
      e.moveTo(3840 * (666 / 768), 0);
      e.lineTo(0,                  0);
      e.lineTo(0,                  250 * (75 / 100));
    }
    e.fill();
    e.fillStyle = 'rgba(1, 142, 66, 1)';
    e.beginPath();
    if (w > breakPoint) {
      e.moveTo(0,        0);
      e.lineTo(1920 * 2, 0);
      e.lineTo(1920 * 2, 125 * 2);
      e.lineTo(0,        32 * 2);
    } else {
      e.moveTo(0,    0);
      e.lineTo(3840, 0);
      e.lineTo(3840, 250 * (100 / 100));
      e.lineTo(0,    250 * (30  / 100));
    }
    e.fill();
  }
  targetLeftArray.forEach((e, i) => {
    const canvas = e.getContext('2d');
    window.addEventListener('load', () => {
      fillLeft(canvas, windowWidth);
    }, false);
    window.addEventListener('resize', () => {
      let resizeWidth = window.innerWidth;
      if (windowWidth != resizeWidth) {
        canvas.clearRect(0, 0, 3840, 250);
        fillLeft(canvas, resizeWidth);
      }
    }, false);
  });
  targetRightArray.forEach((e, i) => {
    const canvas = e.getContext('2d');
    window.addEventListener('load', () => {
      fillRight(canvas, windowWidth);
    }, false);
    window.addEventListener('resize', () => {
      let resizeWidth = window.innerWidth;
      if (windowWidth != resizeWidth) {
        canvas.clearRect(0, 0, 3840, 250);
        fillRight(canvas, resizeWidth);
      }
    }, false);
  });
}



// ------------------------------------------------------------------------
// detectScroll
// ----- BOTH
// ------------------------------------------------------------------------
const detectScroll = () => {
  const targetHeader = document.getElementById('st-Header');
  const targetTotop  = document.getElementById('sw-Totop');
  const targetHeight = 24;
  window.addEventListener('load', () => {
    let scrollVolume = window.pageYOffset;
    if (scrollVolume > targetHeight) {
      targetHeader.classList.add('is-Scrolled');
      targetTotop.classList.add('is-Scrolled');
    } else {
      targetHeader.classList.remove('is-Scrolled');
      targetTotop.classList.remove('is-Scrolled');
    }
  })
  window.addEventListener('scroll', () => {
    let scrollVolume = window.pageYOffset;
    if (scrollVolume > targetHeight) {
      targetHeader.classList.add('is-Scrolled');
      targetTotop.classList.add('is-Scrolled');
    } else {
      targetHeader.classList.remove('is-Scrolled');
      targetTotop.classList.remove('is-Scrolled');
    }
  }, false);
}



// ------------------------------------------------------------------------
// toggleHeader
// ----- BOTH
// ------------------------------------------------------------------------
const toggleHeader = () => {
  const targetHeader = document.getElementById('st-Header');
  const targetButton = document.getElementById('st-Header_Button');
  targetButton.addEventListener('click', () => {
    if (targetHeader.classList.contains('is-Opened')) {
      targetHeader.classList.remove('is-Opened');
    } else {
      targetHeader.classList.add('is-Opened');
    }
  }, false);
}


// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^=#]").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};



export {
  createCanvas,
  detectScroll,
  toggleHeader,
  anchorLink
}



// WEBPACK FOOTER //
// module.js